export const workOrdersEndpoints = {
  getWorkOrders: `/client/work-orders`,
  list: "/work-order/list",
  details: (id: string) => `/work-order/${id}`,
  upcomingVisits: "/visit/upcoming",
} as const;

export const WORK_ORDERS_QUERY_KEYS = {
  list: "workOrdersList",
  details: "workOrderDetails",
  upcomingVisits: "upcomingVisits",
} as const;
